(function () {
  var PREVIEW_PROP = '_cb_price_preview';
  var CACHE_KEY_PREFIX = 'cb_sticky_eff_';

  function readCache(variantId, originalCents) {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY_PREFIX + variantId);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (obj.originalCents !== originalCents) return null;
      return obj;
    } catch (_) { return null; }
  }

  function writeCache(variantId, data) {
    try { sessionStorage.setItem(CACHE_KEY_PREFIX + variantId, JSON.stringify(data)); } catch (_) {}
  }

  function jsonFetch(url, body) {
    var opts = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function cleanupStalePreviewLines() {
    return jsonFetch('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var chain = Promise.resolve();
      items.forEach(function (item) {
        var props = item.properties || {};
        if (props[PREVIEW_PROP]) {
          chain = chain.then(function () {
            return jsonFetch('/cart/change.js', { id: item.key, quantity: 0 }).catch(function () {});
          });
        }
      });
      return chain;
    }).catch(function () {});
  }

  var cleanupOnce = null;
  function ensureCleanup() {
    if (!cleanupOnce) cleanupOnce = cleanupStalePreviewLines();
    return cleanupOnce;
  }

  function previewEffectivePrice(variantId) {
    var addedKey = null;
    var props = {};
    props[PREVIEW_PROP] = '1';
    return jsonFetch('/cart/add.js', { id: variantId, quantity: 1, properties: props })
      .then(function (item) {
        addedKey = item.key;
        return {
          originalCents: item.original_price,
          finalCents: item.final_price,
          hasDiscount: (item.total_discount || 0) > 0
        };
      })
      .then(function (result) {
        if (!addedKey) return result;
        return jsonFetch('/cart/change.js', { id: addedKey, quantity: 0 })
          .catch(function () {})
          .then(function () { return result; });
      });
  }

  var inflight = {};
  function fetchEffective(variantId, originalCents) {
    var cached = readCache(variantId, originalCents);
    if (cached) return Promise.resolve(cached);
    if (inflight[variantId]) return inflight[variantId];
    var p = ensureCleanup()
      .then(function () { return previewEffectivePrice(variantId); })
      .then(function (result) {
        writeCache(variantId, result);
        delete inflight[variantId];
        return result;
      })
      .catch(function (err) {
        delete inflight[variantId];
        console.warn('[sticky-atc] price preview failed:', err);
        return null;
      });
    inflight[variantId] = p;
    return p;
  }

  function reformatPrice(originalFormatted, originalCents, newCents) {
    if (originalFormatted == null || originalCents == null || newCents == null) return originalFormatted;
    var hasComma = /\d,\d/.test(originalFormatted);
    var dec = hasComma ? ',' : '.';
    var origAmount = (originalCents / 100).toFixed(2).replace('.', dec);
    var newAmount = (newCents / 100).toFixed(2).replace('.', dec);
    var idx = originalFormatted.indexOf(origAmount);
    if (idx === -1) return originalFormatted;
    return originalFormatted.slice(0, idx) + newAmount + originalFormatted.slice(idx + origAmount.length);
  }

  function init(bar) {
    if (!bar || bar.__stickyInit) return;
    bar.__stickyInit = true;

    var form = bar.querySelector('[data-sticky-atc-form]');
    var variantInput = bar.querySelector('[data-sticky-atc-variant-id]');
    var colorSelect = bar.querySelector('[data-sticky-atc-color]');
    var variantSelect = bar.querySelector('[data-sticky-atc-variant-select]');
    var button = bar.querySelector('[data-sticky-atc-add]');
    var buttonLabel = bar.querySelector('.sticky-atc__button-label');
    var spinner = bar.querySelector('.sticky-atc__spinner');
    var variantsData = bar.querySelector('[data-sticky-atc-variants]');
    var priceCurrent = bar.querySelector('[data-sticky-atc-price-current]');
    var priceCompare = bar.querySelector('[data-sticky-atc-price-compare]');
    var colorOptionIndex = parseInt(bar.getAttribute('data-color-option-index'), 10);

    var variants = [];
    if (variantsData) {
      try { variants = JSON.parse(variantsData.textContent); } catch (_) {}
    }

    function findVariantById(id) {
      if (id == null) return null;
      var s = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === s) return variants[i];
      }
      return null;
    }

    function applyEffectiveOverride(variantId) {
      var v = findVariantById(variantId);
      if (!v || v.price == null) return;
      fetchEffective(variantId, v.price).then(function (eff) {
        if (!eff || !eff.hasDiscount) return;
        var currentId = variantInput && variantInput.value;
        if (currentId && String(currentId) !== String(variantId)) return;
        if (priceCurrent && v.price_formatted != null) {
          priceCurrent.innerHTML = reformatPrice(v.price_formatted, eff.originalCents, eff.finalCents);
        }
        if (priceCompare && v.price_formatted != null) {
          var hasNativeCompare = v.compare_at_price != null && v.compare_at_price > v.price;
          if (!hasNativeCompare) {
            priceCompare.innerHTML = v.price_formatted;
            priceCompare.hidden = false;
          }
        }
      });
    }

    function updatePriceFor(variantId) {
      var v = findVariantById(variantId);
      if (!v) return;
      if (priceCurrent && v.price_formatted != null) {
        priceCurrent.innerHTML = v.price_formatted;
      }
      if (priceCompare) {
        var hasSale = v.compare_at_price != null && v.price != null && v.compare_at_price > v.price;
        if (hasSale) {
          priceCompare.innerHTML = v.compare_at_price_formatted;
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (variantInput) variantInput.value = v.id;
      applyEffectiveOverride(v.id);
    }

    function getVariantIdFromColor(colorVal) {
      if (!colorVal || colorOptionIndex < 0) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options && v.options[colorOptionIndex] === colorVal && v.available) return v.id;
      }
      for (var j = 0; j < variants.length; j++) {
        var v2 = variants[j];
        if (v2.options && v2.options[colorOptionIndex] === colorVal) return v2.id;
      }
      return null;
    }

    function showError() {
      var target = colorSelect || variantSelect;
      if (target) target.classList.add('is-error');
    }

    function clearError() {
      var target = colorSelect || variantSelect;
      if (target) target.classList.remove('is-error');
    }

    function resetButton() {
      button.disabled = false;
      if (buttonLabel) buttonLabel.textContent = 'Add to Cart';
      if (spinner) spinner.hidden = true;
    }

    if (colorSelect) colorSelect.addEventListener('change', function () {
      clearError();
      var id = getVariantIdFromColor(colorSelect.value);
      if (id) updatePriceFor(id);
    });
    if (variantSelect) variantSelect.addEventListener('change', function () {
      clearError();
      if (variantSelect.value) updatePriceFor(parseInt(variantSelect.value, 10));
    });

    document.addEventListener('variant:update', function (e) {
      var v = e && e.detail && e.detail.resource;
      if (!v || v.id == null) return;
      if (colorSelect && colorOptionIndex >= 0 && v.options) {
        var newColor = v.options[colorOptionIndex];
        if (newColor && colorSelect.value !== newColor) colorSelect.value = newColor;
      }
      if (variantSelect && variantSelect.value !== String(v.id)) variantSelect.value = String(v.id);
      updatePriceFor(v.id);
    });

    // --- FIX 2026-06-20: bridge the main picker's variant change into `variant:update`.
    // Root cause of "ordered black, got army green": nothing in the theme ever emitted
    // the `variant:update` event this bar was built to consume, so the listener above
    // never ran. The bar stayed on its default (first-available) variant and added THAT
    // colour to the cart, regardless of the swatch the customer picked in the main form.
    // product-info.js (updateVariantInputs) sets the main form's input[name="id"] and
    // fires a bubbling `change` on it on every variant switch — translate that into the
    // event this bar already syncs from (keeps colour, price AND submitted variant correct).
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'id') return;
      if (t.closest && t.closest('.sticky-atc__form')) return; // ignore this bar's own hidden id
      var v = findVariantById(t.value);
      if (v) document.dispatchEvent(new CustomEvent('variant:update', { detail: { resource: v } }));
    });

    if (!form) return;

    function xhrRequest(url, data, onSuccess, onFail) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.withCredentials = true;
      xhr.timeout = 15000;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) onSuccess(xhr);
        else onFail(new Error('HTTP ' + xhr.status));
      };
      xhr.onerror = function () { onFail(new Error('Network error')); };
      xhr.ontimeout = function () { onFail(new Error('Timeout')); };
      xhr.send(data);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = null;
      if (colorSelect) {
        if (!colorSelect.value) { showError(); return; }
        variantId = getVariantIdFromColor(colorSelect.value);
        if (!variantId) { showError(); return; }
      } else if (variantSelect) {
        if (!variantSelect.value) { showError(); return; }
        variantId = parseInt(variantSelect.value, 10);
      } else if (variantInput) {
        variantId = parseInt(variantInput.value, 10);
      }

      if (!variantId) { showError(); return; }

      button.disabled = true;
      if (buttonLabel) buttonLabel.textContent = 'Adding…';
      if (spinner) spinner.hidden = false;

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      xhrRequest('/cart/add.js', fd, function () {
        window.location.href = '/cart';
      }, function (err) {
        console.error('[sticky-atc] add failed:', err);
        resetButton();
        window.alert('Could not add to cart.');
      });
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) resetButton();
    });

    var mainWrapper = document.querySelector('product-form, form[action*="/cart/add"]:not(.sticky-atc__form)');
    var footerEl = document.querySelector('.footer, footer.footer, footer[class*="footer"]');

    if (footerEl && footerEl.parentNode && bar.parentNode !== footerEl.parentNode) {
      footerEl.parentNode.insertBefore(bar, footerEl.nextSibling);
    }

    var mainInView = false;
    function applyState() {
      bar.classList.toggle('is-visible', !mainInView);
      if (footerEl) {
        var rect = footerEl.getBoundingClientRect();
        var footerFullyInView = rect.bottom <= window.innerHeight + 4;
        bar.classList.toggle('is-released', footerFullyInView);
      }
    }
    if ('IntersectionObserver' in window && mainWrapper) {
      var mainObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { mainInView = entry.isIntersecting; });
        applyState();
      }, { threshold: 0.1 });
      mainObserver.observe(mainWrapper);
    }
    window.addEventListener('scroll', applyState, { passive: true });
    window.addEventListener('resize', applyState, { passive: true });
    applyState();

    var initialId = variantInput && variantInput.value ? parseInt(variantInput.value, 10) : null;
    if (initialId) applyEffectiveOverride(initialId);
  }

  function bootstrap() {
    document.querySelectorAll('[data-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sticky-atc]');
    if (el) init(el);
  });
})();
